import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, CalendarDays, ClipboardList, Users, FolderOpen, SlidersHorizontal, MessageCircle, LogOut, Globe, Smartphone, CreditCard, Disc3, Star } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const NAV = [
  { to: "/admin", icon: LayoutDashboard, label: "Overview", end: true },
  { to: "/admin/calendar", icon: CalendarDays, label: "Calendar" },
  { to: "/admin/bookings", icon: ClipboardList, label: "Bookings" },
  { to: "/admin/payments", icon: CreditCard, label: "Payments" },
  { to: "/admin/clients", icon: Users, label: "Clients" },
  { to: "/admin/projects", icon: FolderOpen, label: "Projects" },
  { to: "/admin/messages", icon: MessageCircle, label: "Messages" },
  { to: "/admin/sms", icon: Smartphone, label: "Texts" },
  { to: "/admin/releases", icon: Disc3, label: "Releases" },
  { to: "/admin/reviews", icon: Star, label: "Reviews" },
  { to: "/admin/services", icon: SlidersHorizontal, label: "Services & Rates" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-[#F7F5FA] flex" data-testid="admin-dashboard">
      <aside className="w-16 lg:w-64 shrink-0 bg-obsidian text-white flex flex-col fixed inset-y-0 z-40 grain">
        <div className="px-4 lg:px-5 h-16 border-b border-white/10 flex items-center justify-center lg:justify-start gap-3">
          <img src="/logo.jpg" alt="Mixed By Empress" className="w-10 h-10 rounded-full object-cover ring-1 ring-[#D4AF37]/50 shrink-0" />
          <div className="hidden lg:block">
            <span className="text-[10px] font-mono uppercase tracking-[0.25em] text-gold">Studio Control</span>
          </div>
        </div>
        <nav className="flex-1 py-6 px-2 lg:px-3 space-y-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} data-testid={`admin-nav-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-3 rounded-xl text-sm transition-colors ${
                  isActive ? "bg-gold/15 text-gold border border-gold/30" : "text-white/55 hover:text-white hover:bg-white/5 border border-transparent"
                }`
              }>
              <n.icon size={17} className="shrink-0" />
              <span className="hidden lg:block">{n.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-white/10 space-y-1">
          <Link to="/" data-testid="admin-view-site" className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-white/50 hover:text-gold hover:bg-white/5 transition-colors">
            <Globe size={15} className="shrink-0" /> <span className="hidden lg:block">View website</span>
          </Link>
          <button onClick={doLogout} data-testid="admin-logout-btn"
            className="w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-white/50 hover:text-red-300 hover:bg-white/5 transition-colors">
            <LogOut size={15} className="shrink-0" /> <span className="hidden lg:block">Sign out ({user?.name})</span>
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-16 lg:ml-64 p-4 sm:p-8 lg:p-12 max-w-6xl">
        <Outlet />
      </main>
    </div>
  );
}
